import React, { useContext, useState } from "react";
import { arenaLabPage } from "../../../portfolio";
import StyleContext from "../../../contexts/StyleContext";
import "./ArenaLabPublications.css";

// Map tag names to consistent colors (0-19) - each unique skill gets its own color
const TAG_COLOR_MAP = {
  // Publication tags
  "Benchmarking": 0,
  "Social Navigation": 1,
  "Collaboration": 2,
  "Photorealistic": 3,
  "ROS2": 4,
  "Simulation": 5,
  "Human-Centric": 6,
  "AI Generation": 7,
  "Platform": 8,
  "Development": 9,
  "Web Platform": 10,
  "Dynamic Environments": 11,
  "Dynamics": 12,
  "Obstacle Avoidance": 13,
  "Dynamic": 14,
  "Deep RL": 15,
  "Navigation": 16,
  "Control": 17,
  // Team research interests
  "Human-Robot Interaction": 18,
  "Behavioral Modeling": 19,
  "Embodied AI": 0,
  "Robot Learning": 1,
  "Autonomous Navigation": 2,
  "Manipulation": 3,
  "Learning from Demonstration": 4,
  "Sim2Real Transfer": 5,
  "Multi-Agent RL": 6,
  "Robot Teams": 7,
  "Crowd Simulation": 8,
  "Computer Vision": 9,
  "Semantic Perception": 10,
  "Scene Understanding": 11,
  "Software Engineering": 12,
  "ROS Development": 13
};

const getTagColorIndex = (tagName) => {
  return TAG_COLOR_MAP[tagName] !== undefined ? TAG_COLOR_MAP[tagName] : Object.keys(TAG_COLOR_MAP).length % 20;
};

export default function ArenaLabPublications() {
  const { isDark } = useContext(StyleContext);
  const [showAll, setShowAll] = useState(false);
  
  // Show only the first 5 publications initially
  const visiblePublications = showAll 
    ? arenaLabPage.publications 
    : arenaLabPage.publications.slice(0, 5);

  return (
    <div className="arena-lab-section publications-section" id="lab-publications">
      <h2 className="section-title">Publications</h2>
      <div className="publications-container">
        {visiblePublications.map((pub, index) => (
          <div key={index} className={`publication-card ${isDark ? "dark-mode" : ""}`}>
            <div className="pub-header">
              <h3 className="pub-title">{pub.title}</h3>
              <span className="pub-date">{pub.date}</span>
            </div>
            
            <p className="pub-authors">{pub.authors}</p>
            <p className="pub-venue">{pub.venue}</p>
            
            {pub.tags && pub.tags.length > 0 && (
              <div className="pub-tags">
                {pub.tags.map((tag, i) => (
                  <span key={i} className={`pub-tag tag-${getTagColorIndex(tag)}`}>{tag}</span>
                ))}
              </div>
            )}
            
            {pub.footerLink && pub.footerLink.length > 0 && (
              <div className="pub-links">
                {pub.footerLink.map((link, i) => (
                  link.url ? (
                    <a key={i} href={link.url} target="_blank" rel="noopener noreferrer" className="pub-link">
                      {link.name}
                    </a>
                  ) : null
                ))}
              </div>
            )}
            
            {pub.image && (
              <div className="pub-image-container">
                <img src={pub.image} alt={pub.title} className="pub-image" />
              </div>
            )}
          </div>
        ))}
      </div>
      
      {arenaLabPage.publications.length > 5 && (
        <div className="show-more-container">
          <button 
            onClick={() => setShowAll(!showAll)} 
            className={`show-more-btn ${isDark ? "dark-mode" : ""}`}
          >
            {showAll ? (
              <>
                Show Less <span className="arrow-icon">▲</span>
              </>
            ) : (
              <>
                Show More Publications ({arenaLabPage.publications.length - 5} more) <span className="arrow-icon">▼</span>
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
}
